// utils/dateHelpers.js
export const sortOnDate = (array) => {
  return [...array].sort((a, b) => {
    const [dayA, monthA, yearA] = a.Date.split('-');
    const [dayB, monthB, yearB] = b.Date.split('-');
    return new Date(yearA, monthA - 1, dayA) - new Date(yearB, monthB - 1, dayB);
  });
};